import { useMutation } from "@tanstack/react-query"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Menu, useMenu } from "@/shared/components"
import { currLang, type ILang, type ILangLabel, LANG_I18KEYS, LANG_OPTIONS, SHORT_LANG } from "@/shared/config/locales.ts"
import queryClient from "@/shared/config/query-client"
import { CustomIconButton } from "@/shared/ui/custom-icon-button.tsx"
import { requestAuth } from "@/shared/utils/axios"

const setLanguage = async (lang: keyof ILang) => {
  const apiLang = lang === "uzKr" ? "uz-cr" : lang
  return (await requestAuth.post("/user/set-language/", { language: apiLang })).data
}

const optionsLabel: Record<ILangLabel, string> = {
  ЎЗ: "Ўзбекча",
  "O‘Z": "O'zbekcha",
  РУ: "Русский"
}
export const useSetLanguage = () => {
  return useMutation({
    mutationFn: setLanguage
  })
}
export const LanguageChanger = () => {
  // Helpers
  const { i18n } = useTranslation()
  const { menuProps, targetProps, setOpen } = useMenu()
  const currentLocale = i18n.language

  // State
  const [lang, setLang] = useState<keyof ILang>(currLang)

  // Queries
  const { mutate: setLanguage } = useSetLanguage()

  // Effects
  useEffect(() => {
    queryClient.invalidateQueries({ refetchType: "active" })
  }, [currentLocale])

  // Functions
  const handleLanguageChange = (lang: keyof ILang) => {
    i18n.changeLanguage(LANG_I18KEYS[lang])
    setLang(lang)
    localStorage.setItem("i18nextLng", LANG_I18KEYS[lang])
    setOpen(false)
  }

  return (
    <div>
      <div {...targetProps}>
        <CustomIconButton className="uppercase">{SHORT_LANG[lang]}</CustomIconButton>
      </div>
      <Menu {...menuProps}>
        {LANG_OPTIONS.map(({ label, value }) => (
          <Menu.Item className="p-3" onClick={() => handleLanguageChange(value)} key={value} label={optionsLabel[label]} />
        ))}
      </Menu>
    </div>
  )
}
